import Fn from 'jj-browser-fn';
import PageApi from '@/apis/pageApi'
import cookies from "./cookie"
import md5 from "js-md5"
import httpApi from '@/apis/httpApi';
const ProjFn = {
    ...Fn,
    cookies,
    // 跳转路由
    toRoute: (route: string) => {
        window.App.$router.push({
            path: route,
        })
    },
    backLogin: () => {
        window.App.$router.push({
            path: PageApi.login.path,
        })
    },
    // 添加全局公共方法
    checkHttpResponse: (res: any, errorFn: any, isNotice: boolean) => {
        return new Promise((resolve) => {
            if (res && ProjFn.n(res.code) === 200) {
                resolve(res.data)
            } else {
                // tslint:disable-next-line:no-unused-expression
                errorFn ? errorFn(res) : '';
                if (isNotice) {
                    window.App.$Message.error(res.msg)
                }
            }
        })
    },
    showMsgResponse: (res: any, errorFn?: any) => {
        return ProjFn.checkHttpResponse(res, errorFn, true)
    },
    handleResponse: (res: any, errorFn: any) => {
        return ProjFn.checkHttpResponse(res, errorFn, false)
    },
    substr(val) {
        const num = val.substring(0, val.indexOf("."));
        const str = val.substring(val.length - 3);
        const replaceString = `${num}<span style="font-size: 14px;">${str}</span>`;
        return replaceString;
    },
    // 转换成时间
    toTimes: (time) => {
        if (!time) {
            return ""
        } else {
            const date = new Date(time * 1000);
            const dateNumFun = (num) => num < 10 ? `0${num}` : num
            const [Y, M, D, h, m, s] = [
                date.getFullYear(),
                dateNumFun(date.getMonth() + 1),
                dateNumFun(date.getDate()),
                dateNumFun(date.getHours()),
                dateNumFun(date.getMinutes()),
                dateNumFun(date.getSeconds())
            ]

            return `${Y}-${M}-${D} ${h}:${m}:${s}`;
        }
    },
    // 保留两位小数
    byHundred: (num) => {
        return parseFloat((num / 100).toFixed(2))
    },
    // 身份证号机密显示
    idCard: (idCard: any) => {
        return idCard.replace(
            /(\d{4})\d*([0-9a-zA-Z]{4})/, "$1**********$2"
        );
    },
    // 接口验签
    toSign: (obj: any, signObj?: any) => {
        // 获取版本
        const version = ProjFn.getBoxVersion();
        // 按照升序排序obj属性
        const sortObj = ProjFn.returnResetInfo(version, JSON.parse(JSON.stringify(obj)));
        // 生成随机数
        const chars = [
          '0',
          '1',
          '2',
          '3',
          '4',
          '5',
          '6',
          '7',
          '8',
          '9',
          'A',
          'B',
          'C',
          'D',
          'E',
          'F',
          'G',
          'H',
          'I',
          'J',
          'K',
          'L',
          'M',
          'N',
          'O',
          'P',
          'Q',
          'R',
          'S',
          'T',
          'U',
          'V',
          'W',
          'X',
          'Y',
          'Z'
        ];
        let resNum = '';
        for (let i = 0; i < 32; i++) {
          const id = Math.ceil(Math.random() * 35);
          resNum += chars[id];
        }
        const newkey = Object.keys(sortObj).sort();
        const newObj: any = {};
        newkey.forEach((item, i) => {
          // 遍历newkey数组
          newObj[newkey[i]] = sortObj[newkey[i]];
          // 向新创建的对象中按照排好的顺序依次增加键值对
        });
        const keyArr: any = []
        for (const y in newObj) {
          if (true) {
            const x = newObj[y];
            keyArr.push(x);
            if (newObj[y] === undefined || newObj[y] == null) {
              newObj[y] = '';
            }
          }
        }
        newObj.rqtime = Date.parse(String(new Date()));
        newObj.rqrandom = resNum;
        if (signObj) {
          keyArr.push(newObj.rqtime)
          keyArr.push(newObj.rqrandom)
          if (ProjFn.getNewSign()) {
            keyArr.push(httpApi.newSignKey)
          } else {
            keyArr.push(httpApi.signKey)
          }
        } else {
          keyArr.push(httpApi.signKeyV0);
          keyArr.push(newObj.rqtime)
          keyArr.push(newObj.rqrandom)
        }
        let sginStr = '';
        keyArr.forEach(item => {
          if (typeof item == 'object') {
            return JSON.stringify(item);
          }
        });
        // 将字符串按验签规则拼接
        for (const y in keyArr) {
          if (true) {
            if (typeof keyArr[y] == 'object' && keyArr[y] != null) {
              sginStr = sginStr + JSON.stringify(keyArr[y]);
            } else if (keyArr[y] === undefined || keyArr[y] == null) {
              keyArr[y] = '';
              const sginArr = sginStr;
              sginStr = sginArr;
            } else {
              sginStr = sginStr + keyArr[y];
            }
          }
        }
        if (signObj) {
          const str = JSON.parse(JSON.stringify(sginStr));
          const value = `appv=${signObj.appv}&device=${signObj.device}&deviceId=${
            signObj.deviceId
          }&box-agent=${ProjFn.headerBoxAgent(signObj)}&${ProjFn.getNewSign() ? str : sginStr}`;
          newObj.sign = md5(value);
        } else {
          newObj.sign = md5(sginStr);
        }
        return newObj;
      },
    getBoxVersion() {
      let appv = cookies.getVersion();
      appv = appv ? appv : "2.9.0";
      const strVersion: any = appv.replace(/&.+/, '');
      const numVersion = strVersion.replace(/[^0-9]/g, '');
      const mainVersion = numVersion.slice(0, 3);
      return Number(mainVersion);
    },
    sortObjectValues(obj: any): any {
      if (typeof obj !== 'object' || obj === null) return obj;
      if (Array.isArray(obj)) return obj.map(ProjFn.sortObjectValues);
      const sortedKeys = Object.keys(obj).sort();
      const sortedObj = {};
      sortedKeys.forEach(key => {
        sortedObj[key] = ProjFn.sortObjectValues(obj[key]);
      });
      return sortedObj;
    },
    returnResetInfo(version: number, obj: any) {
      if (typeof obj === 'string') obj = JSON.parse(obj);
      delete obj.rqrandom;
      delete obj.rqtime;
      delete obj.sign;
      if (ProjFn.getNewSign()) return ProjFn.sortObjectValues(obj);
      return obj;
    },
    getNewSign() {
        const version = ProjFn.getBoxVersion();
        let flag = false;
        if (version >= 371) {
        // if ((ProjFn.cookies.getIsios() === 'ios' && version >= 371) || version >= 382) {
            flag = true;
        } else {
            flag = false;
        }
        return flag;
    },
    headerBoxAgent: (obj: any) => {
        const param = Object.keys(obj)
        const data = Object.values(obj)
        let sign = ''
        param.forEach((item, index) => {
        const val = data[index] === undefined ? '' : data[index]
        sign += `${item}:${val};`
        })
        return sign
    },
    gitIsVersion(versionNum) {
      let appv = (window as any).appv;
      appv = appv ? appv : "2.9.0";
      const isVersion =
      Number(
          appv.replace(/&.+/, "").replace(/[^0-9]/g, "").slice(0, 3)
      ) >= versionNum;
      return isVersion;
    },
    // 截取url
    parseQuery: (url) => {
        const o = {};
        const queryString = url.split("?")[1];
        if (queryString) {
            queryString.split("&").forEach((item) => {
                let [key, val] = item.split("=");
                val = val ? decodeURI(val) : true;
                key = key ? decodeURI(key) : true;
                //          转码         无值赋值true
                if (o.hasOwnProperty(key)) {
                    //   已有属性转为数组
                    o[key] = [].concat(o[key], val);
                } else {
                    o[key] = val;
                }
            });
        }
        return o;
    },
    // // 传递参数给ios  调ios的返回
    // sendIos: (val) => {
    //     (window as any).webkit.messageHandlers.saveUnreadMsgCnt.postMessage(
    //         {
    //             key: "getUrl",
    //             data: {
    //                 back: "1",
    //                 url: "",
    //                 tologin: ""
    //             },
    //             callBack: "callBack"
    //         }
    //     )
    // },
    // // 传递参数给ios  调ios的返回
    // sendUrl: (urls) => {
    //     (window as any).webkit.messageHandlers.iOSWKMethod.postMessage({
    //         "key": "getUrl",
    //         "data": {
    //             back: "1",
    //             url: urls,
    //             tologin: "1"
    //         },
    //         "callBack": "callBack"
    //     });
    // },
    // // 传递参数给ios  调ios的返回
    // sendLogin: (val) => {
    //     (window as any).webkit.messageHandlers.saveUnreadMsgCnt.postMessage(
    //         {
    //             key: "getUrl",
    //             data: {
    //                 back: "",
    //                 url: "",
    //                 tologin: "1"
    //             },
    //             callBack: "callBack"
    //         }
    //     )
    // },
    onClickLeft: () => {
        // this.$router.go(-1);
        // this.$fn.sendIos(1);
        // const u = navigator.userAgent;
        // console.log(u);
        // const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android安卓
        // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios苹果

        if ((window as any).mb) {
            (window as any).sendIos();
        } else {
            window.App.$router.go(-1);
        }
    }
}

export default ProjFn;


